import React from "react";
import { bracketedTextClass } from "./styles";

type Props = {
  text: string;
};

// Matches luggage tags such as "[ABC-123]". The capturing group keeps them in split() output.
const LUGGAGE_TAG_REGEX = /(\[.*?-.*?\])/;

/**
 * Renders text (e.g. an email subject) with luggage tags kept on one line.
 * Output is plain React text, so any HTML in the input is escaped, not rendered.
 */
const LuggageTagText: React.FC<Props> = ({ text }) => (
  <>
    {text.split(LUGGAGE_TAG_REGEX).map((part, i) =>
      // split() with a capturing group puts the matched tags at odd indices
      i % 2 === 1 ? (
        <span key={i} className={bracketedTextClass}>
          {part}
        </span>
      ) : (
        <React.Fragment key={i}>{part}</React.Fragment>
      )
    )}
  </>
);

export default LuggageTagText;
